<script>
import Layout from '@layouts/auth'

/**
 * Página de manutenção
 */
export default {
    components: { Layout },
    data() {
        return {
            // Configurações da página de manutenção
            maintenanceConfig: {
                title: 'Sistema em Manutenção',
                message: 'Nosso sistema está temporariamente indisponível para manutenção programada.',
                estimatedTime: 'Estamos trabalhando para retomar o serviço o mais rápido possível.',
                contactInfo: 'Em caso de urgência, entre em contato com nossa equipe de suporte.'
            }
        }
    },
    methods: {
        // Método para verificar se ainda está em manutenção
        checkMaintenanceStatus() {
            // Recarrega a página para verificar o status atual
            window.location.reload()
        }
    }
}
</script>

<template>
    <Layout>
        <div class="row justify-content-center">
            <div class="d-flex">
                <div class="card-body p-5">
                    <div class="text-center w-100 m-auto">
                        <a href="/">
                            <span>
                                <img
                                    class="img-fluid"
                                    src="@assets/images/logo-login.png"
                                    alt
                                    height="116"
                                />
                            </span>
                        </a>
                    </div>

                    <!-- Container de manutenção -->
                    <div class="maintenance-container text-center mt-4">
                        <!-- Ícone de manutenção -->
                        <div class="maintenance-icon mb-4">
                            <i class="fas fa-tools fa-3x text-white"></i>
                        </div>

                        <!-- Título -->
                        <h2 class="maintenance-title text-white mb-3">
                            {{ maintenanceConfig.title }}
                        </h2>

                        <!-- Mensagem principal -->
                        <p class="maintenance-message text-white-50">
                            {{ maintenanceConfig.message }}
                        </p>

                        <!-- Tempo estimado -->
                        <p class="maintenance-time text-white-50">
                            {{ maintenanceConfig.estimatedTime }}
                        </p>

                        <!-- Informações de contato -->
                        <p class="maintenance-contact text-white-50">
                            {{ maintenanceConfig.contactInfo }}
                        </p>
                    </div>
                </div>
                <!-- end card-body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
.maintenance-container {
    padding: 2rem 1rem;
}

.maintenance-icon {
    animation: pulse 2s infinite;
}

.maintenance-title {
    font-size: 1.75rem;
    font-weight: 600;
}

.maintenance-message,
.maintenance-time,
.maintenance-contact {
    margin-bottom: 0;
    font-size: 1rem;
}

.maintenance-button {
    padding: 0.75rem 2rem;
    font-weight: 500;
    border-radius: 25px;
    transition: all 0.3s ease;
}

.maintenance-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
}

@keyframes pulse {
    0% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.8;
        transform: scale(1.05);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
